var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extra-block gallery"},[_c('media-uploader',{staticClass:"mt-8",attrs:{"documents":_vm.model.media,"resourceName":"projects","uuid":_vm.projectUUID,"disabled":_vm.disabled,"allowMultiple":true},on:{"added":_vm.onAdded,"deleted":_vm.onDeleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }